export default {"src":"https://cdn.jetlend.ru/_next/static/media/data-role.1149a64e.svg","height":12,"width":232,"blurWidth":0,"blurHeight":0};